export const SERVICE_STATUS = {
	ACTIVE: 'ACTIVE',
	INACTIVE: 'INACTIVE',
	PENDING: 'PENDING',
	PENDING_ACTIVATION: 'PENDING_ACTIVATION',
	PENDING_TERMINATION: 'PENDING_TERMINATION',
};
